module.exports = __webpack_public_path__ + "img/IMG_2559.0bcd95f0.jpg";